import { render, staticRenderFns } from "./AModal-reporteFeria3.vue?vue&type=template&id=389cdf1e"
import script from "./AModal-reporteFeria3.vue?vue&type=script&lang=js"
export * from "./AModal-reporteFeria3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports